import { NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Shipment } from 'app-modules/core/models/shipment.model';
import { ShipmentDetailComponent } from 'app-modules/shipment-detail/components/shipment-detail/shipment-detail.component';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-u-shipment-details',
  templateUrl: './u-shipment-details.component.html',
  styleUrls: ['./u-shipment-details.component.css'],
  standalone: true,
  imports: [ShipmentDetailComponent, NgIf]
})
export class UShipmentDetailsComponent implements OnInit {

  selectedShipment: Shipment;
  constructor(private r: ActivatedRoute) {
    this.r.paramMap
      .pipe(map(_ => window.history.state))
      .subscribe(s => {
        this.selectedShipment = s?.shipment;
      });
   }

  ngOnInit(): void {
  }



}
